import React from 'react'
import { Outlet } from 'react-router-dom'

const BilleteraComponent = () => {
  return (
    <div>
        <Outlet/>
    </div>
  )
}

export default BilleteraComponent